<template>
    <div style="min-height:300px;"><!-- min height because list goes off page -->
        <!--<div class="form-group">-->
            <!--<label class="control-label">Add New Invoice</label>-->
        <!--</div>-->
        <div class="create-invoice">
            <button @click="createNew" class="btn btn-success"><i class="icon icon-create-thin"></i> {{ trans('create_invoice') }}</button>
            <p class="instruct-sm">Create a new blank invoice.</p>
        </div>

        <div class="form-group">
            <label class="control-label">Invoice Template</label>
            <invoice-templates v-model="template"></invoice-templates>
        </div>
        <p class="instruct-sm">Create an invoice from a template. To create invoice templates, simply add a tag named 'Invoice Template' to an existing invoice. Your templates will load here. </p>

        <div class="buttons" style="margin-top: 0px;">
            <button @click="create" class="btn btn-success"><i class="icon icon-create-thin"></i> {{ trans('create_invoice') }}
            </button>
        </div>

    </div>
</template>
<script>
    export default {
        components: {
            'invoice-templates': require('../../components/invoice-template-list.vue').default,
        },
        data() {
            return {
                template: {},
            }
        },
        created() {},
        methods: {
            createNew() {
                this.template.id = false;
                this.create();
            },
            create() {
                let url = '';
                if(typeof window.company_id !== 'undefined') {
                    url = '/company/' + company_id;
                } else if(typeof window.currentCompany !== 'undefined') {
                    url = '/company/' + currentCompany.id;
                }
                if (typeof this.template['id'] !== 'undefined' && this.template.id) {
                    window.location =  url + '/invoice/create?inv_id=' + this.template.id;
                    return;
                }
                window.location =  url + '/invoice/create';
            }
        }
    }
</script>